// KAN-549: tiny bus so a platform data loader that hits 401/403 can ask
// PlatformRoute to re-validate the session + platform access. No React/router.
const listeners = new Set();

export function onPlatformAccessRecheck(fn) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/**
 * Resolves 'ended' (session revoked / account inactive — the route takes over),
 * 'active' (still fine) or 'unknown' (no listener, offline, or failure).
 * Listeners may return a promise of one of those.
 */
export async function requestPlatformAccessRecheck(reason) {
  const results = await Promise.all(Array.from(listeners).map(async (fn) => {
    try { return await fn(reason); } catch (_) { return 'unknown'; }
  }));
  if (results.includes('ended')) return 'ended';
  if (results.includes('active')) return 'active';
  return 'unknown';
}

/** HTTP status of a FunctionsHttpError without consuming its body (0 when unknown). */
export function functionErrorStatus(error) {
  const s = error?.context?.status;
  return typeof s === 'number' ? s : 0;
}

export function isAuthDeniedError(error) {
  const s = functionErrorStatus(error);
  return s === 401 || s === 403;
}

/**
 * Loader helper. Returns true when the caller must NOT paint the raw server
 * message (401/403 and the re-check says the session/access ended — the route
 * is taking over). Awaiting keeps the loader in its loading state meanwhile.
 * Any other outcome returns false so the normal error UI shows as today.
 */
export async function shouldSuppressAuthDeniedError(error, reason) {
  if (!isAuthDeniedError(error)) return false;
  return (await requestPlatformAccessRecheck(reason)) === 'ended';
}
